import React from 'react';

/**
 * JobastiIQ brand wordmark.
 *
 *   Jobasti — primary brand color (blue-600, or white when mono)
 *   IQ     — accent color for a subtle two-tone treatment
 *
 * @param {number}  height       pixel height of the wordmark
 * @param {string}  className    extra wrapper classes
 * @param {boolean} mono         white-on-dark variant (for footers etc.)
 * @param {string}  suffixColor  override for the "IQ" accent (hex or CSS color)
 */
const JobastiLogo = ({ height = 36, className = '', mono = false, suffixColor }) => {
  const baseColor = mono ? '#FFFFFF' : '#0F172A';       // slate-900 (near-black)
  const accent    = suffixColor || (mono ? '#93C5FD' : '#2563EB'); // blue-600

  return (
    <span
      className={`inline-flex items-center leading-none notranslate ${className}`}
      translate="no"
      style={{
        height,
        fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
        fontWeight: 700,
        fontSize: height * 0.86,
        letterSpacing: '-0.02em',
        color: baseColor,
      }}
      data-testid="jobasti-logo"
    >
      Jobasti<span style={{ color: accent }}>IQ</span>
    </span>
  );
};

export default JobastiLogo;
